import React from 'react'

function BlackList() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 512 512">

            <rect x="40" y="40" width="300" height="420" rx="20" ry="20"
                fill="white" stroke="#3E4A62" stroke-width="20" />


            <rect x="100" y="80" width="180" height="180" rx="15" ry="15"
                fill="none" stroke="#3E4A62" stroke-width="16" />


            <circle cx="190" cy="140" r="35" fill="#3E4A62" />
            <path d="M120 225 Q190 160 260 225 Z" fill="#3E4A62" />


            <line x1="80" y1="300" x2="280" y2="300" stroke="#3E4A62" stroke-width="20" stroke-linecap="round" />
            <line x1="80" y1="360" x2="280" y2="360" stroke="#3E4A62" stroke-width="20" stroke-linecap="round" />
            <line x1="80" y1="420" x2="280" y2="420" stroke="#3E4A62" stroke-width="20" stroke-linecap="round" />


            <circle cx="390" cy="390" r="90" fill="#fff" stroke="#3E4A62" stroke-width="20" />
            <line x1="350" y1="350" x2="430" y2="430" stroke="#3E4A62" stroke-width="24" stroke-linecap="round" />
            <line x1="430" y1="350" x2="350" y2="430" stroke="#3E4A62" stroke-width="24" stroke-linecap="round" />


        </svg>


    )
}

export default BlackList